import PartnerPageTable from "./PartnerPageTable";
export default function PartnerPaymentsPage() { return <PartnerPageTable title="Վճարումների պատմություն" subtitle="Դիտեք ստացված հանձնաժողովների պատմությունը" rows={[]} payments />; }
